export default "__VITE_ASSET__DnKwBfsP__"